/** Devises supportées par commerçant (affichage & caisse) */
export const DEVISES_COMMERCANT = [
  { code: 'EUR', label: 'Euro (€)', symbole: '€', locale: 'fr-FR' },
  { code: 'MAD', label: 'Dirham marocain (MAD)', symbole: 'MAD', locale: 'fr-MA' },
];

export const DEVISE_DEFAUT = 'EUR';

export function getDeviseConfig(code) {
  return DEVISES_COMMERCANT.find((d) => d.code === code) || DEVISES_COMMERCANT[0];
}
